export default {
  title: 'Einstellungen',
  kickerDesktop: 'Alles, was diese Instanz braucht – nichts davon steht im Code',
  kickerMobile: 'Gilt für diese Instanz',
  back: 'Mehr',
  loadError: 'Einstellungen lassen sich gerade nicht laden.',
  retry: 'Nochmal versuchen',
  loading: 'Lädt …',
  area: {
    quellen: 'Datenquellen', anmeldung: 'Anmeldung', sportarten: 'Sportarten', zonen: 'Zonen', sprache: 'Sprache & Einheiten',
    darstellung: 'Darstellung', ki: 'KI & Datenschutz', daten: 'Daten', wetter: 'Wetter',
  },
  areaSub: {
    wetter: 'Wetter an Aktivitäten mit GPS, von Open-Meteo',
    anmeldung: 'Wer die App öffnen darf. Gewählt beim Einrichten über die Server-Umgebung, hier nur angezeigt.',
    sportarten: 'Je Sport Name, Tempo-Anzeige und welche Zonen die Last bestimmen',
    zonen: 'Versioniert – jede Aktivität wird mit den Zonen ausgewertet, die an ihrem Tag galten',
  },
  mobile: {
    groupSources: 'Datenquellen',
    groupAuth: 'Anmeldung',
    groupTraining: 'Training',
    groupGeneral: 'Allgemein',
    garmin: 'Garmin Personal API',
    strava: 'Strava-Export (ZIP)',
    fit: 'FIT hochladen',
    intervals: 'intervals.icu',
    imported: 'Importiert',
    open: 'Offen',
    ready: 'Bereit',
    active: 'Aktiv',
    noLogin: 'Ohne eigenen Login',
    oidc: 'Login-Dienst (OIDC)',
    authActive: 'aktiv · {how}',
    authOidcHow: 'Passkeys verwaltet der Dienst',
    authProxyHow: 'hinter anmeldendem Proxy',
    authLater: 'kommt vor dem Deploy',
    sports: 'Sportarten',
    zones: 'Zonen',
    zonesSub: 'v{version} · gültig ab {date}',
    zonesNone: 'noch keine',
    language: 'Sprache & Einheiten',
    languageSub: 'Deutsch · metrisch · Woche ab Montag',
    theme: 'Darstellung',
    ai: 'KI & Datenschutz',
    weatherSub: 'Open-Meteo · an Aktivitäten mit GPS',
    weather: 'Wetter',
    aiSub: 'Anbieter · Wochenkommentar · was die KI sieht',
    data: 'Daten',
    dataSub: 'Archiv {size} · CSV-Export · Neuaufbau',
  },
  general: {
    language: 'Sprache · Language',
    units: 'Einheiten',
    metric: 'Metrisch (km, m, kg)',
    imperial: 'Imperial (kommt später)',
    weekStart: 'Woche beginnt am',
    monday: 'Montag',
    weekHint: 'Fest auf Montag (ISO-Woche), wie Serien und Wochensummen rechnen.',
    theme: 'Darstellung',
    themeSystem: 'Wie das System',
    themeLight: 'Hell',
    themeDark: 'Dunkel',
    themeHint: 'Gilt für diesen Browser.',
  },
  data: {
    confirmRebuild: 'Datenbank aus dem Rohdaten-Archiv neu aufbauen? Zonen, Sportarten und eigene Titel/Notizen bleiben. Das dauert je nach Archiv einige Minuten.',
    summary: 'Rohdaten-Archiv {archive} ({files} Dateien) · Datenbank {db} · {activities} Aktivitäten · {days} Health-Tage',
    rebuilding: 'Baut neu auf …',
    rebuild: 'Datenbank aus Archiv neu aufbauen',
    export: 'Alles als CSV exportieren',
    running: 'Neuaufbau läuft seit {since} …',
    done: 'Neu aufgebaut {ago}: {versions} Fassungen, {files} Health-Dateien.',
    failed: 'Neuaufbau fehlgeschlagen: {error}',
    csvNote: 'CSV: eine Zeile je Aktivität mit Zeit, Sport, Titel, Dauer, Distanz, Puls, Last und Quelle – ohne Koordinaten.',
  },
  sources: {
    garminKeyMissing: 'GARMIN_API_KEY fehlt',
    keyExpires: 'Key läuft ab {date}',
    historyFrom: 'Historie ab {date}',
    noData: 'noch keine Daten',
    stravaOnce: 'einmalig · {n} Fassungen',
    stravaNot: 'noch nicht importiert',
    fitUploaded: '{n} hochgeladen',
    fitExample: 'z. B. Wahoo-Fahrten',
    intervalsOk: 'bringt Workouts aufs Gerät · {n} gesendet',
    intervalsMissing: 'INTERVALS_API_KEY fehlt',
    uploadCreated: 'Aktivität angelegt.',
    uploadDuplicate: 'Schon vorhanden – keine Dublette angelegt.',
    uploadFailed: 'Upload fehlgeschlagen: {error}',
    uploadBusy: 'Lädt …',
    uploadButton: 'FIT hochladen',
    error: 'Fehler:',
    metaKeyExpires: 'Key läuft ab: {date}',
    metaActivities: 'Aktivitäten {from} – {to}',
    metaHealth: 'Health {from} – {to}',
    lastFetchFailed: 'letzter Abruf fehlgeschlagen {ago}',
    lastFetch: 'letzter Abruf {ago}',
    neverFetched: 'noch nie abgerufen',
    garminDesc: 'Aktivitäten samt FIT-Datei und alle Gesundheitswerte. Abruf stündlich und per Knopf.',
    syncRunning: 'Läuft …',
    syncNow: 'Jetzt synchronisieren',
    stravaDesc: 'Einmalig für die Zeit vor Garmin. Dubletten: Messdaten bleiben von Garmin, Titel und Notiz werden übernommen.',
    stravaTaken: '{n} übernommen',
    stravaReplaced: '{n} als Dublette verdrängt',
    stravaNone: 'noch kein Export importiert',
    stravaButton: 'Strava-Export hochladen',
    stravaUploading: 'Lädt hoch … {mb} MB',
    stravaRunning: 'Importiert … {read} von {total} Aktivitäten',
    stravaDone: 'Fertig: {created} neu, {merged} zusammengeführt, {skipped} schon bekannt, {errors} Fehler',
    stravaFailed: 'Import fehlgeschlagen: {error}',
    stravaCli: 'Sehr große Exporte (mehrere GB) besser über die Kommandozeile: {cmd}',
    fitDesc: 'Datei hochladen – beim Rad ersetzt sie die Garmin-Fassung derselben Fahrt.',
    fitFiles: '{n} Dateien',
    fitLast: 'zuletzt: {date}',
    fitNone: 'noch keine Datei hochgeladen',
    intervalsDesc: 'Nur für die Planung: Workouts gehen über intervals.icu auf Garmin bzw. Wahoo.',
    intervalsOnDevice: '{n} Einheiten auf dem Gerät',
    intervalsNoKey: 'Ohne Key bleibt alles Entwurf – INTERVALS_API_KEY (und optional INTERVALS_ATHLETE_ID) setzen',
    footKeys: 'Schlüssel liegen nur in der Server-Umgebung ({env}) – nie im Repo, nie im Browser. Garmin verrät den Ablauf des Keys nicht; wer ihn kennt, trägt ihn als {expires} ein.',
  },
  auth: {
    secret: 'Secret {state}',
    secretSet: 'gesetzt',
    secretMissing: 'fehlt',
    proxyHeader: 'Header Remote-User nur von TRUSTED_PROXIES',
    noneTitle: 'Noch keine Anmeldung eingerichtet.',
    noneText: 'Anmeldung kommt vor dem Deploy – bis dahin läuft die App nur lokal ohne Login.',
    oidcTitle: 'Login-Dienst (OIDC)',
    oidcDesc: 'Anmeldung über einen vorhandenen Dienst wie Authentik, Keycloak, Pocket ID oder Google.',
    proxyTitle: 'Ohne eigenen Login',
    proxyDesc: 'Für das Heimnetz oder hinter einem Proxy, der schon anmeldet (z. B. Tailscale, Cloudflare Access).',
    active: 'Aktiv',
    off: 'Aus',
    foot: 'Passkeys, Zwei-Faktor und Konten verwaltet der Login-Dienst, nicht dashy-dash. Ohne eine der beiden Einstellungen startet die App später nicht – sie ist nie versehentlich offen.',
  },
  sports: {
    loadHr: 'Herzfrequenz',
    loadPowerOrHr: 'Leistung, sonst Herzfrequenz',
    loadEstimate: 'Herzfrequenz, sonst ~ geschätzt',
    nameDe: 'Name (Deutsch)',
    nameEn: 'Name (Englisch)',
    pace: 'Tempo',
    noPace: 'ohne Tempo',
    loadZones: 'Zonen für Last',
    saving: 'Speichert …',
    save: 'Speichern',
    cancel: 'Abbrechen',
    headSport: 'Sport',
    headPace: 'Tempo',
    headLoad: 'Zonen für Last',
    headActivities: 'Aktivitäten',
    mobilePace: 'Tempo ',
    mobileLoad: 'Last ',
    mobileActivities: ' Aktivitäten',
    edit: '{name} bearbeiten',
    foot: 'Die Sportarten sind fest vorgegeben – jede Aktivität landet in einer davon, Unbekanntes unter „Sonstiges". Namen, Tempo-Anzeige und Zonen für die Last lassen sich über den Stift bearbeiten.',
  },
  zones: {
    allSports: 'alle Sportarten',
    sourceGarmin: 'Garmin',
    sourceUser: 'eigene',
    validFrom: 'Gültig ab',
    appliesTo: 'Gilt für',
    restHr: 'Ruhepuls',
    maxHr: 'Max-HF',
    lthr: 'Schwelle (LTHR)',
    optional: 'optional',
    floors: 'Untergrenzen in bpm',
    model: 'Zonenmodell',
    modelLthr: '% Laktatschwelle (LTHR)',
    modelHrr: '% Herzfrequenzreserve (Karvonen)',
    modelMax: '% Max-HF',
    modelBpm: 'Eigene bpm',
    pcts: 'Untergrenzen in %',
    preview: 'Ergibt in bpm',
    lthrFallback: 'Ohne Schwelle rechnet dashy-dash nach % Max-HF (50 · 60 · 69 · 80 · 89 %). Trag die Schwelle ein, dann gelten die Prozente oben.',
    modelMeta: 'Modell: {model} · {pcts} %',
    modelMetaFallback: 'Modell: {model}, ohne Schwelle nach % Max-HF',
    recomputing: 'Berechnet neu …',
    saveRecompute: 'Speichern & neu berechnen',
    createRecompute: 'Anlegen & neu berechnen',
    cancel: 'Abbrechen',
    current: ' · aktuell',
    validFromShort: 'gültig ab {date}',
    source: 'Quelle: {source}',
    meta: 'Ruhepuls {rest} · Max-HF {max} · Schwelle {lthr} · {n} Aktivitäten',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    lastGeneral: 'Die letzte Version für alle Sportarten bleibt stehen',
    recomputed: '~{changed} Aktivitäten neu berechnet ({checked} geprüft).',
    confirmDelete: 'Version v{version} ({scope}, ab {date}) löschen? Die Last wird neu berechnet.',
    newVersion: 'Neue Version ab …',
    empty: 'Noch keine Zonen – der erste Garmin-Sync übernimmt sie, oder lege eine Version an.',
    foot: 'Jede Aktivität wird mit den Zonen ausgewertet, die an ihrem Tag galten. Eigene Versionen überschreibt der Garmin-Sync nicht; jede Änderung berechnet die Last aller betroffenen Aktivitäten neu.',
  },
  ai: {
    statusError: 'KI-Status nicht verfügbar: {error}',
    loading: 'Lädt …',
    provider: 'KI-Anbieter',
    claude: 'Claude (Anthropic)',
    openai: 'OpenAI (später)',
    ollama: 'Ollama, lokal (später)',
    off: 'Aus',
    status: 'Status',
    on: 'An · {model}',
    isOff: 'KI ist aus',
    reasonHint: '{reason}. Gewählt wird über die Server-Umgebung: {provider} und {key}.',
    weekly: 'Wochenkommentar montags',
    activity: 'Kommentar zu jeder Aktivität',
    weeklyPending: 'Greift erst, wenn ein KI-Anbieter läuft.',
    lastGenerated: 'Zuletzt erzeugt {ago} für die Woche ab {week} mit {model}',
    lastError: 'Letzter Fehler',
    hideStarts: 'Startorte in Exporten ausblenden',
    radius: 'Radius 300 m',
    sent: 'An den Anbieter geht{when}:',
    sentLater: ' (sobald eingeschaltet)',
    never: 'Nie:',
    foot: 'Die KI sieht nur Daten aus Garmin, Wahoo und deinem eigenen Strava-Export. Workouts gehen nie ohne deinen Klick aufs Gerät.',
    usage: {
      title: 'Verbrauch',
      loading: 'Verbrauch lädt …',
      error: 'Verbrauch nicht verfügbar: {error}',
      month: 'Monat',
      ofBudget: '{spent} von {budget}',
      noLimit: '{spent} · kein Limit',
      meter: 'KI-Verbrauch im {month}',
      exhausted: 'Das Budget für {month} ist aufgebraucht. Die Planungs-Chats pausieren bis zum nächsten Monat oder bis du es erhöhst; die Kommentare laufen weiter.',
      feature: 'Bereich',
      requests: 'Anfragen',
      tokens: 'Token',
      cost: 'Kosten',
      total: 'Summe',
      features: {
        unit_chat: 'Einheiten-Chat',
        plan_chat: 'Planungs-Chat',
        activity: 'Aktivitätskommentare',
        weekly: 'Wochenkommentar',
        plan_week: 'Wochenbegründung (Planung)',
      },
      budget: 'Monatsbudget in $',
      budgetPlaceholder: 'kein Limit',
      budgetHint: 'Leer lassen für kein Limit, sonst 0,50 bis 500 $. Ist es aufgebraucht, pausieren die beiden Planungs-Chats; die Kommentare laufen weiter.',
      budgetInvalid: 'Bitte einen Betrag zwischen 0,50 und 500 $ eingeben – oder das Feld leer lassen.',
      save: 'Speichern',
      saving: 'Speichert …',
      saved: 'Budget gespeichert.',
      unpriced: { one: '{count} Anfrage lief mit einem Modell ohne Preis in der Tabelle und zählt mit 0 $.', other: '{count} Anfragen liefen mit einem Modell ohne Preis in der Tabelle und zählen mit 0 $.' },
      foot: 'Die Kosten sind aus den Token und einer Preistabelle berechnet – eine Schätzung. Was wirklich abgerechnet wird, steht in der Anthropic Console.',
    },
  },
};
